// extracted by mini-css-extract-plugin
module.exports = {"v6v4agf":"v6v4agf","scroll-wrapper":"scroll-wrapper"};